import React, {useEffect, useMemo, useState} from "react"
import FormSectionAccordion from "../../../../../components/FormSectionAccordion"
import theme from "../../../../../theme/theme"
import {ReactComponent as CheckIcon} from "../../../../../assets/icons/check-icon.svg"
import PropTypes from "prop-types"
import {renderGrid} from "../../../../../components/FieldRenderer"
import {mapRatingEmissao, ratingFields} from "./constants"
import {Box} from "@mui/material"
import ButtonWithIcon from "../../../../../components/Button/Button"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import EmissaoService from "../../../../../../services/emissao-service"

const RatingSection = (
    {
        caracteristicasState,
        state,
        setRatingState,
        setSectionField,
        isValid,
        showError,
        actions,
        defaultOpen = false,
        syncToken = 0,
        autoCompleteController = {}
    }) => {

    const ratingService = useMemo(() => new EmissaoService(), [])
    const [cetipRating, setCetipRating] = useState(null)

    useEffect(() => {
        if (caracteristicasState) {
            const {cetip} = caracteristicasState
            if (cetip === cetipRating) return
            setCetipRating(cetip)
            loadRatingEmissao(cetip)
        }
    }, [caracteristicasState])

    const loadRatingEmissao = (cetip) => {
        const query_params = `?CETIP=${cetip}&ordering=DataReferencia`
        ratingService.ratingEmissao('get', query_params)
            .then((response) => {
                const {body: {results}} = response

                if (results.length > 0) {
                    const ratingEmissao = mapRatingEmissao(results[0])
                    console.log(ratingEmissao)
                    setRatingState(ratingEmissao)
                    return
                }
                setSectionField("rating", {})
            })
            .catch((err) => {
                console.error("Não foi possível carregar os dados de rating emissao", err)
            })
            .finally(() => {

            })
    }

    const createRatingEmissao = () => {
        // todo: em andamento criar rating
    }

    return (
        <FormSectionAccordion
            title={"Rating Emissão"}
            icon={<CheckIcon style={{color: theme.palette.icon.main, width: 20, height: 20}}/>}
            isValid={isValid}
            showError={showError}
            actions={actions}
            defaultOpen={defaultOpen}
            syncToken={syncToken}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "right",
                    mt: 3,
                    mb: 3,
                }}
            >
                <ButtonWithIcon size="md" icon={<AddCircleOutlineIcon/>} onClick={createRatingEmissao}>
                    CADASTRAR RATING
                </ButtonWithIcon>
            </Box>
            {renderGrid(
                ratingFields,
                state,
                (key) => (value) => setSectionField("rating", key, value),
                undefined,
                undefined,
                (key) => (value) => setSectionField("rating", key, value),
                autoCompleteController
            )}
        </FormSectionAccordion>
    )
}

RatingSection.propTypes = {
    caracteristicasState: PropTypes.object,
    state: PropTypes.object.isRequired,
    setRatingState: PropTypes.func.isRequired,
    setSectionField: PropTypes.func.isRequired,
    isValid: PropTypes.bool,
    showError: PropTypes.bool,
    actions: PropTypes.node,
    defaultOpen: PropTypes.bool,
    syncToken: PropTypes.number,
    autoCompleteController: PropTypes.object,
}

export default RatingSection